/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/isFunction */
function t(n){return typeof n=="function"}export{t as isFunction};
//# sourceMappingURL=isFunction.mjs.map